import React, { useEffect } from "react";
import CustomersComp from "../Components/Customers/Customers";
const Customers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <CustomersComp />
    </div>
  );
};

export default Customers;
